import { render } from "./AccountWorkspace.vue?vue&type=template&id=28c6dbc0&scoped=true"
import script from "./AccountWorkspace.vue?vue&type=script&lang=js"
export * from "./AccountWorkspace.vue?vue&type=script&lang=js"

import "./AccountWorkspace.vue?vue&type=style&index=0&id=28c6dbc0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c6dbc0"]])

export default __exports__